import React from 'react';
import { useBatteryStore } from '../../store/batteryStore';
import { Button } from '../ui/button';
import { 
  Grid3X3, 
  Axis3D, 
  Tag,
  Box,
  CircuitBoard
} from 'lucide-react';

export const ViewportControls = () => {
  const { 
    showGrid, 
    showAxes, 
    showLabels,
    viewMode,
    toggleGrid, 
    toggleAxes, 
    toggleLabels,
    setViewMode
  } = useBatteryStore();
  
  return (
    <>
      <div className="absolute top-4 left-4 flex flex-col gap-2 z-10" data-testid="viewport-controls">
        {/* View Mode Toggle */}
        <div className="flex gap-1 bg-zinc-900/80 backdrop-blur-sm rounded-lg p-1 border border-zinc-700">
          <Button
            size="icon"
            variant={viewMode === '3d' ? 'default' : 'ghost'}
            className={`h-8 w-8 ${viewMode === '3d' ? 'bg-blue-600' : ''}`}
            onClick={() => setViewMode('3d')}
            data-testid="view-3d-btn"
            title="3D View"
          >
            <Box className="h-4 w-4" />
          </Button>
          
          <Button
            size="icon"
            variant={viewMode === 'routing' ? 'default' : 'ghost'}
            className={`h-8 w-8 ${viewMode === 'routing' ? 'bg-blue-600' : ''}`}
            onClick={() => setViewMode('routing')}
            data-testid="view-routing-btn"
            title="Electrical Routing"
          >
            <CircuitBoard className="h-4 w-4" />
          </Button>
        </div>
        
        {/* 3D Controls (only shown in 3D mode) */}
        {viewMode === '3d' && (
          <div className="flex flex-col gap-1 bg-zinc-900/80 backdrop-blur-sm rounded-lg p-1 border border-zinc-700">
            <Button
              size="icon"
              variant={showGrid ? 'default' : 'ghost'}
              className={`h-8 w-8 ${showGrid ? 'bg-cyan-600/50' : ''}`}
              onClick={toggleGrid}
              data-testid="toggle-grid-btn"
              title="Toggle Grid"
            >
              <Grid3X3 className="h-4 w-4" />
            </Button>
            
            <Button
              size="icon"
              variant={showAxes ? 'default' : 'ghost'}
              className={`h-8 w-8 ${showAxes ? 'bg-cyan-600/50' : ''}`}
              onClick={toggleAxes}
              data-testid="toggle-axes-btn"
              title="Toggle Axes"
            >
              <Axis3D className="h-4 w-4" />
            </Button>
            
            <Button
              size="icon"
              variant={showLabels ? 'default' : 'ghost'}
              className={`h-8 w-8 ${showLabels ? 'bg-cyan-600/50' : ''}`}
              onClick={toggleLabels}
              data-testid="toggle-labels-btn"
              title="Toggle Labels"
            >
              <Tag className="h-4 w-4" />
            </Button>
          </div>
        )}
      </div>
      
      {/* Bottom-right info */}
      <div className="absolute bottom-4 right-4 z-10">
        <div className="bg-zinc-900/80 backdrop-blur-sm rounded px-2 py-1 text-[10px] font-mono text-zinc-500 border border-zinc-700">
          {viewMode === '3d' ? 'Drag to rotate • Scroll to zoom' : 'Electrical Routing View'}
        </div>
      </div>
    </>
  );
};
